import axios from 'axios'

// 创建axios实例
const service = axios.create({
  baseURL: '/api/admin', // 代理会处理这个路径
  timeout: 5000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 这里可以添加token，不过根据需求不做token验证
    return config
  },
  error => {
    console.log(error) // 用于调试
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data

    return res
  },
  error => {
    console.log("🚀 error::::::", error)

    return Promise.reject(error)
  }
)

export default service